import { useState,useEffect } from "react";
import Pagination from "../../Common/Pagination";
import axiosInstance from "../../../utils/axiosInstance";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { API_ENDPOINTS } from "../../../constants/config";

const FeeHistoryTable = ({ studentId, onSendReminder }) => {
  const [feeHistory, setFeeHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    if (studentId) {
      fetchFeeHistory();
    }
  }, [studentId]);

  const fetchFeeHistory = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axiosInstance.get(API_ENDPOINTS.feesHistory, {
        headers: { Authorization: `Bearer ${token}` },
        params: { studentId }
      });

      if (response.data.status === "success") {
        setFeeHistory(response.data.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching fee history:", error);
      setError("Failed to load fee history");
      setLoading(false);
    }
  };

  if (loading) return <div>Loading fee history...</div>;
  if (error) return <div className="text-red-500">{error}</div>;

  return (
    <div className="space-y-4">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Fee Name</TableHead>
            <TableHead>Due Date</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Amount</TableHead>
            <TableHead>Payment Method</TableHead>
            <TableHead>Payment Date</TableHead>
            <TableHead>Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {feeHistory.slice((page - 1) * itemsPerPage, page * itemsPerPage).map((history) => {
            const academicYearDisplay = history.academicYear 
              ? (typeof history.academicYear === 'object' 
                  ? `${history.academicYear.startYear}-${history.academicYear.endYear}`
                  : history.academicYear)
              : 'N/A';
            
            return (
              <TableRow key={history._id}>
                <TableCell>
                  {history.description || `${academicYearDisplay} - ${history.quarter ? history.quarter.toUpperCase() : ''} Fee`}
                </TableCell>
                <TableCell>
                  {history.paidDate 
                    ? new Date(history.paidDate).toLocaleDateString()
                    : history.date 
                    ? new Date(history.date).toLocaleDateString()
                    : 'N/A'}
                </TableCell>
                <TableCell>
                  <span
                    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium
                    ${history.status === 'success'
                      ? 'bg-green-100 text-green-800'
                      : history.status === 'pending'
                      ? 'bg-yellow-100 text-yellow-800'
                      : 'bg-red-100 text-red-800'
                    }`}
                  >
                    {history.status ? history.status.charAt(0).toUpperCase() + history.status.slice(1) : 'Pending'}
                  </span>
                </TableCell>
                <TableCell>₹{history.totalAmount || history.amount || 0}</TableCell>
                <TableCell>{history.paymentMethod || 'N/A'}</TableCell>
                <TableCell>
                  {history.paidDate 
                    ? new Date(history.paidDate).toLocaleDateString()
                    : history.isPaid 
                    ? 'Paid'
                    : 'Not Paid'}
                </TableCell>
                <TableCell>
                  {history.status !== 'success' && (
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => onSendReminder && onSendReminder(history)}
                    >
                      Send Reminder
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>

      {feeHistory.length === 0 && (
        <div className="text-center py-8">
          <p className="text-gray-500">No fee history available</p>
        </div>
      )}
      <Pagination
        currentPage={page}
        totalItems={feeHistory.length}
        itemsPerPage={itemsPerPage}
        onPageChange={setPage}
        onItemsPerPageChange={(newLimit) => { setItemsPerPage(newLimit); setPage(1); }}
        itemLabel="records"
      />
    </div>
  );
};

export default FeeHistoryTable;